import { Icon } from "@blueprintjs/core"
import React from "react"
import MarkersPreview from "components/Templates/MarkersPreview"
import { useCurrentDepartmentAccess } from "graphql/auth/auth.hooks"
import { getPosition } from "utils/custom.utils"
import Format from "utils/Format"

const OrdersPreview = ({ bookings }) => {
  const isEcom = useCurrentDepartmentAccess()
  const locationMap = bookings?.reduce((prev, b) => {
    const address = b?.shippingAddress ?? b?.schedule?.plot?.address
    const position = address && JSON.stringify(getPosition(address))

    const orderStatus = b?.orderStatus
    return {
      ...prev,
      [position]: {
        name: b?.trackingCode ? b?.user?.fullName : b?.schedule?.plot?.name,
        village: address?.village,
        distict: address?.distict,
        location: getPosition(address),
        status: orderStatus,
        marker: isEcom
          ? orderStatus === "CMP"
            ? "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
            : orderStatus === "PRJ"
            ? "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
            : orderStatus === "FRJ"
            ? "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi-dotless2_hdpi.png"
            : "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
          : undefined,
        bookings: prev[position]?.bookings
          ? // In case of a front-end trip append all the bookingsByTrip on a order
            // In case of a backend trip simply append the booking
            prev[position]?.bookings?.concat(b?.bookingsByTrip ?? b)
          : b?.bookingsByTrip ?? [b],
      },
    }
  }, {})

  const locations = locationMap && Object.values(locationMap)
  return (
    <MarkersPreview
      list={locations}
      getLabel={isEcom ? () => null : undefined}
      renderIcon={item => {
        return item?.marker
          ? {
              scaledSize: new window.google.maps.Size(43, 43),
              url: item?.marker,
            }
          : undefined
      }}
      getPosition={item => item.location}
    >
      {data => {
        return (
          <>
            {data?.name && <p className="m-0">{data?.name}</p>}
            <p className="vt-muted m-0">
              {data?.village}, {data?.distict}
            </p>
            {Object.values(data.bookings)?.map?.(booking => {
              const itemName =
                booking?.orderItem?.sellableItem?.name ||
                Format.variety(booking?.schedule?.variety)

              return (
                <p key={booking?.id} className="mt-1 mb-0">
                  <Icon icon="box" intent="primary" /> <span>{itemName}</span>
                  <span className="ml-1 vt-highlight">
                    {booking?.procuredQuantity ?? 0} /{" "}
                    {booking?.requiredQuantity ?? 0}
                  </span>
                </p>
              )
            })}
          </>
        )
      }}
    </MarkersPreview>
  )
}

export default OrdersPreview
